import { Navigate } from 'react-router-dom';

export default function DetailsList() {
  return <Navigate to="/search?searchType=details" replace />;
}
